'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useNavbarContext } from './Context';
const NavbarCollapse = forwardRef(({ children, className, ...props }, ref) => {
    const { open } = useNavbarContext();
    if (!open) {
        return null;
    }
    return (_jsx("div", { ref: ref, ...props, className: cn('absolute right-0 top-full z-50 flex h-auto w-full flex-col items-start gap-2.5 overflow-hidden rounded-xl rounded-t-none border border-metal-100 bg-white p-6 sm:w-[20rem] lg:hidden dark:border-metal-800 dark:bg-metal-900', className), children: children }));
});
NavbarCollapse.displayName = 'NavbarCollapse';
export { NavbarCollapse };
